import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

export const apolloClient = new ApolloClient({
  link: new RestLink({
    uri: process.env.REACT_APP_API_URL,
    //Configuraciones necesarias en el módulo FaqContainer
    endpoints: {
      endpointFeedback: process.env.REACT_APP_FEEDBACK_API_URL!,
    },
    headers: {
      recaptchapub: process.env.REACT_APP_FEEDBACK_API_KEY!,
    },
  }),
  cache: new InMemoryCache(),
});
